// Frontend auth helpers. Uses Emergent-managed Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import axios from "axios";
import { getAnonymousTeacherId } from "./teacher";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Dedicated axios instance for auth so we can be explicit about credentials.
export const authApi = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

export const startGoogleLogin = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href =
    "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
};

export const exchangeSession = async (sessionId) => {
  const { data } = await authApi.post("/auth/session", { session_id: sessionId });
  return data;
};

export const fetchMe = async () => {
  const { data } = await authApi.get("/auth/me");
  return data;
};

export const logout = async () => {
  await authApi.post("/auth/logout");
};

export const migrateAnonymous = async () => {
  const anon = getAnonymousTeacherId({ create: false });
  if (!anon) return { migrated: 0 };
  const { data } = await authApi.post("/auth/migrate-anonymous", {
    anonymous_teacher_id: anon,
  });
  return data;
};

export const updateTeacherProfile = async ({ grades_taught, subjects_taught, privacy_consent }) => {
  const { data } = await authApi.put("/auth/profile", {
    grades_taught,
    subjects_taught,
    privacy_consent: !!privacy_consent,
  });
  return data;
};

export const deleteMyAccount = async () => {
  const { data } = await authApi.delete("/auth/account");
  return data;
};
